var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-notification"},[_vm._t("default"),(_vm.number)?_c('div',{staticClass:"chat-notification__badge",style:({
      width: _vm.notificationWidth
    })},[_vm._v("\n    "+_vm._s(_vm.number > 99 ? '99+': _vm.number)+"\n  ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }